<template>
<v-container>
<v-data-table
    :items="users"
    :headers="headers"
    disable-sort
    dense
    class="nn"
>
<template v-slot:item.action="{item}">
<v-row>
    <v-col cols="2">
        <v-btn small @click="change_pw(item)">
            <v-icon>mdi-key</v-icon>
        </v-btn>
    </v-col>
    <v-col cols="2">
        <v-btn small @click="del_user(item)">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
    </v-col>
</v-row>
</template>
<template v-slot:top>
    <v-row style="width: 100%">
    <v-col align="right">
        <v-btn @click="show">
            Add User
        </v-btn>
        <v-dialog
            v-model="dialog"
            max-width="500"
        >
        <v-card>
            <v-card-title>
                Add User
            </v-card-title>
            <v-card-text>
                <v-row class="ma-1">
                    <v-col cols="6" class="pb-0 pt-0">
                        <v-text-field
                            label="User name"
                            type="text"
                            v-model="user_name"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0" cols="6">
                        <v-text-field
                            label="password"
                            type="password"
                            v-model="user_pw"
                        >
                        </v-text-field>
                    </v-col>
                    <v-col class="pt-0 pb-0 ma-0" cols="6">
                        <v-phone
                            label="phone"
                            v-model="phone"
                            no-country-selector
                            default-country-code="KR"
                            color="red"
                            valid-color="green"
                            @update="update_phone"
                        >
                        </v-phone>
                    </v-col>
                    <v-col class="pt-0 pb-0" cols="6">
                        <v-combobox
                            label="Group"
                            v-model="group"
                            :items="['ADMIN', 'USER']"
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col align="right">
                    <v-btn color="primary" @click="add">
                        Add
                    </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>

    </v-col>
    </v-row>
</template>
</v-data-table>
</v-container>
</template>
<script>
import gql from 'graphql-tag'
import Swal from 'sweetalert2'
export default {
    name: 'UserManager',
    props: ['value'],
    methods: {
        show() {
            this.phone = null;
            this.user_name = null;
            this.user_pw = null;
            this.group = 'USER'
            this.dialog = true
        },
        update_phone(e) {
            this.phone = e.phoneNumber;
        },
        del_user({name, id}) {
            Swal.fire({
                title: `Delete user ${name}`,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'confirm'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$apollo.mutate({
                            mutation: gql`mutation DelUser($id: Int!) {
                            delUser(id: $id)
                            }`,
                            variables: {
                                id
                            },
                        }).then((v) => {
                            this.$apollo.queries.users.refetch()
                            Swal.fire({
                                icon: "success",
                                title: "Sucess to remove user",
                                showConfirmButton: false,
                                toast: true,
                                timer: 1000
                            });
                        })
                    }
                })
        },
        change_pw({id, name}) {
            Swal.fire({
            title: `Change password of ${name}`,
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Change',
            showLoaderOnConfirm: true,
            }).then((result) => {
            if (result.isConfirmed) {
                this.$apollo.mutate({
                    mutation: gql `
                            mutation ChangePW($id: Int!, $password: String!) {
                            changePW(id: $id, password: $password)
                            }
                        `,
                    variables: {
                        id, password: result.value
                    }
                })
            }})
        },
        add() {
            if (this.phone == null || this.user_name == null || this.user_pw == null) {
                Swal.fire({
                    icon: "error",
                    title: "Invalid data",
                });
                return;
            }
            this.dialog = false
            this.$apollo.mutate({
                mutation: gql `
                mutation CreateUser($name: String!, $pw: String!, $phone: String!, $group: String!) {
                    createUser(name: $name, password: $pw, phone: $phone, group: $group)
                }
                    `,
                variables: {
                    name: this.user_name,
                    pw: this.user_pw,
                    phone: this.phone,
                    group: this.group
                }
            }).then((e) => {
                if (e.data.createUser) {
                    Swal.fire({
                        icon: "success",
                        title: "Sucess to add user",
                        showConfirmButton: false,
                        toast: true,
                        timer: 1000
                    });
                    this.$apollo.queries.users.refetch()
                }
            }).catch((e) => {
                Swal.fire({
                    icon: "error",
                    text: e.message,
                });
            });
        }
    },
    data: () => {
        return {
            expanded: [],
            singleExpand: false,
            headers: [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'name',
                    value: 'name'
                },
                {
                    text: 'phone',
                    value: 'phone'
                },
                {
                    text: 'group',
                    value: 'group'
                },
                {
                    text: 'action',
                    value: 'action',
                },
            ],
            dialog: false,
            phone: '',
            user_name: '',
            user_pw: '',
            group: 'USER',
        }
    },
    apollo: {
        users: {
            query: gql`{
                users {
                    name
                    phone
                    group
                    id
                }
                }`,
            result(q) {
                this.$emit('input', q.data.users)
            },
        }
    }

}
</script>

<style scoped>
.cc {
    margin-left: 2px;
    margin-right: 2px;
}
</style>